module.exports = __webpack_public_path__ + "img/SZ.59e2dbc4.svg";